<template>
  <ul class="category-list clearfix">
    <li class="category-item fl"
      v-for="item in list"
      :key="item.classId"
      :class="{'is-active': current === item.classId}"
      @click="handleCateTap(item.classId)">{{ item.className }}</li>
  </ul>
</template>

<script>
export default {
  props: {
    list: Array,
    current: String
  },
  methods: {
    handleCateTap (data) {
      this.$emit('onCategoryChanged', data);
    }
  }
};
</script>

<style scoped>
@import 'config.css';
.category-list {
  position: relative;
  border-bottom: 1px solid $global-border-color;
  padding: 15px 0;
  background-color: #fff;
}
.category-item {
  margin-right: 50px;
  text-align: center;
  cursor: pointer;
  &.is-active {
    color: $global-primary-color;
  }
}
@media (--sm-viewport) {
  .category-list {
    padding: 15px;
  }
}
</style>
